var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 60.8332C80.0081 60.8332 86.5 54.4159 86.5 46.4998C86.5 38.5838 80.0081 32.1665 72 32.1665C63.9919 32.1665 57.5 38.5838 57.5 46.4998C57.5 54.4159 63.9919 60.8332 72 60.8332Z",
    fill: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87.7085C101 96.6131 101 103.833 72 103.833C43 103.833 43 96.6131 43 87.7085C43 78.8039 55.9847 71.5835 72 71.5835C88.0153 71.5835 101 78.8039 101 87.7085Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ae6f5197b4e301405c87cb326caa4004.svg";
export { ForwardRef as ReactComponent };